"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefaultCountryForBrand = exports.getDefaultCountryForBrand = exports.DEFAULT_COUNTRY_BY_BRAND = void 0;
const types_1 = require("../types");
exports.DEFAULT_COUNTRY_BY_BRAND = {
    [types_1.Brand.BK]: types_1.IsoCountryCode2Char.US,
    [types_1.Brand.LTW]: types_1.IsoCountryCode2Char.US,
    [types_1.Brand.PLK]: types_1.IsoCountryCode2Char.US,
    [types_1.Brand.TH]: types_1.IsoCountryCode2Char.CA,
    [types_1.Brand.FHS]: types_1.IsoCountryCode2Char.US,
};
/**
 * Determine the default country value for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @returns {IsoCountryCode2Char}
 * The default 2-character ISO country code for the Brand.
 */
const getDefaultCountryForBrand = (brand) => exports.DEFAULT_COUNTRY_BY_BRAND[brand];
exports.getDefaultCountryForBrand = getDefaultCountryForBrand;
/**
 * Given a country value, determine if it is the default country for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @param {IsoCountryCode2Char | string} country
 * A country value.
 *
 * @returns {boolean}
 * true - The country value is the default for the Brand.
 * false - Otherwise.
 */
const isDefaultCountryForBrand = (brand, country) => (0, exports.getDefaultCountryForBrand)(brand) === country;
exports.isDefaultCountryForBrand = isDefaultCountryForBrand;
//# sourceMappingURL=brand.js.map